import { render, staticRenderFns } from "./LKRoadmapsFeedToggleLine.vue?vue&type=template&id=bfadb7e6&"
import script from "./LKRoadmapsFeedToggleLine.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedToggleLine.vue?vue&type=script&lang=js&"
import style0 from "./LKRoadmapsFeedToggleLine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
